module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.params.id != 'me') ? _c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Benachrichtigungen")])]) : _vm._e(), _vm._v(" "), _c('section', [_c('notifications', {
    attrs: {
      "notifications": _vm.notifications
    }
  }), _vm._v(" "), _c('infinite-loading', {
    on: {
      "infinite": _vm.scrollHandler
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("\n                Hier ist noch nichts los :("), _c('br'), _vm._v("\n                Füge Freunde hinzu, um das zu ändern!\n            ")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("\n                Es gibt keine weiteren Benachrichtigungen.\n            ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54e18fc4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/notification-archive.vue
// module id = 228
// module chunks = 0